
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[creatorSlug]",
      function () {
        return require("private-next-pages/[creatorSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[creatorSlug]"])
      });
    }
  